import { computed, Ref } from 'vue'
import { useGetJobStopsQuery } from '@/api/jobs'
import { useCurrentOrg } from '@/common/useCurrentOrg'
import { JobStopType } from 'ironsight-types'

export const useJobStopsAndInventoryReceipts = (jobUuid: Ref<string>) => {
  const { data: stopsData, isLoading: isStopLoading } =
    useGetJobStopsQuery(jobUuid)
  const { currentOrg } = useCurrentOrg()
  const hasExistingDestinationLocationReceipts = computed(() => {
    const matchingStops = stopsData.value?.filter(
      (s) => s.stopType === JobStopType.DropOff
    )

    if (!matchingStops || matchingStops.length === 0) {
      return false
    }

    const matchingReceipts = matchingStops[0].inventoryReceipts.filter(
      (r) => r.ownerOrgId === currentOrg.value?.id
    )
    return matchingReceipts.length > 0
  })
  return {
    stopsData,
    isStopLoading,
    hasExistingDestinationLocationReceipts,
  }
}
